// import { Exercise, ExerciseCreateRequest, ExerciseCreateRequestGroupEnum, ExerciseSearchRequest, ExerciseSearchResponse, User } from '@api/entities';
import { Exercise, ExerciseCreateRequest, ExerciseSearchRequest, ExerciseSearchResponse } from 'src/api/entities';
import { ExerciseApiClients, IExerciseApiClients } from './exercise.api.client';
import * as jsonpatch from "fast-json-patch";

export interface IExerciseApiService {
  search(request: ExerciseSearchRequest): Promise<Array<Exercise>>;
  create(request: ExerciseCreateRequest): Promise<Exercise>;
  updateURL(uuid: string, url: string): Promise<Exercise>;
  getByUuid(uuid: string): Promise<Exercise>;
  edit(oldTicket: Exercise, updatedTicket: Exercise): Promise<Exercise>;
  delete(uuid: string): Promise<{ [key: string]: boolean; }>
}

export class ExerciseApiService implements IExerciseApiService {
    protected static instance: IExerciseApiService;
    protected api: IExerciseApiClients;

    protected constructor(basePath: string) {
        this.api = ExerciseApiClients.getInstance(basePath);
    }
    static getInstance(basePath: string) {
        if (ExerciseApiService.instance == null) {
            ExerciseApiService.instance = new ExerciseApiService(basePath);
        }
        return ExerciseApiService.instance;
    }


    async create(request: ExerciseCreateRequest): Promise<Exercise> {
      const response: Exercise = (
        await this.api.exercise.create14(request)
      ).data;
      return response;
    }
    
    async updateURL(uuid: string, url: string): Promise<Exercise> {
      const response: Exercise = (
        await this.api.exercise.updateUrl(uuid, url)
      ).data;
      return response;
    }

    async edit(oldTicket: Exercise, updatedTicket: Exercise): Promise<Exercise> {
      const requestPatch: any = jsonpatch.compare(oldTicket, updatedTicket);
      const exercise: Exercise = (
          await this.api.exercise.patch6(oldTicket.uuid!, requestPatch)
      ).data;
      return exercise;
  }

    async search(request: ExerciseSearchRequest): Promise<Array<Exercise>> {
      const response: ExerciseSearchResponse = (
        await this.api.exercise.search10(request)
      ).data;
      return response.data!;
    }

    async getByUuid(uuid: string): Promise<Exercise> {
      return (await this.api.exercise.getByUuid1(uuid)).data;
  }

  async delete(uuid: string): Promise<{ [key: string]: boolean; }> {
      const response: { [key: string]: boolean; } = (await this.api.exercise.deleteByUuid2(uuid)).data
      return response
  }
}
